




import { Component, Mixins } from "vue-property-decorator";
import {
  IDrawableItem,
} from "../../../../domain/document/items";
import {
  Point,
  Vector,
  Rectangle,
} from "../../../../domain/drawing";
import ObjectLocator from "../ObjectLocator.vue";
import { DocumentPageEditor } from "../contents";

@Component
export default class PageEditor extends Mixins() {
  setEditor(editor: DocumentPageEditor): void {
    this.editor = editor;
  }

  data() {
    return {
      editor: null as DocumentPageEditor,
    };
  }
  editor: DocumentPageEditor;

  private async doLocate<T>(locate: (locator: ObjectLocator) => Promise<T>): Promise<T> {
    return this.editor
      ? locate(this.editor.getLocator())
      : null;
  }

  async locateItem(requester: any, source: IDrawableItem): Promise<Point> {
    return this.doLocate(l => l.locateItem(requester, source));
  }

  async locateItemVertically(requester: any, source: IDrawableItem): Promise<Point> {
    return this.doLocate(l => l.locateItemVertically(requester, source));
  }

  async layoutRectangleItem(requester: any, source: IDrawableItem, fixedAspectRatio?: number): Promise<Rectangle> {
    return this.doLocate(l => l.layoutRectangleItem(requester, source, fixedAspectRatio));
  }

  async layoutLinearItem(requester: any, source: IDrawableItem): Promise<Vector> {
    return this.doLocate(l => l.layoutLinearItem(requester, source));
  }

  async layoutPointsItem(requester: any, source: IDrawableItem): Promise<Point[]> {
    return this.doLocate(l => l.layoutPointsItem(requester, source));
  }

  async selectRectangle(requester: any): Promise<Rectangle> {
    return this.doLocate(l => l.selectRectangle(requester));
  }

  cancel(requester: any): void {
    if (this.editor) {
      // 文書登録後のdestroyedのタイミングではlocatorがundefinedになっているのでガードを入れている
      const locator = this.editor.getLocator();
      if (locator) {
        locator.cancel(requester);
      }
    }
  }
}
